import { Component, type ReactNode, type ErrorInfo } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="text-center max-w-sm">
            <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
              style={{ background: 'var(--sf-bg-card)', border: '1px solid var(--sf-border-light)' }}>
              <span className="text-4xl">🥀</span>
            </div>
            <h1 className="text-xl font-semibold mb-2">Что-то пошло не так</h1>
            <p className="text-sm mb-6" style={{ color: 'var(--tg-theme-hint-color, #999)' }}>
              Произошла непредвиденная ошибка. Попробуйте перезагрузить приложение.
            </p>
            <button
              onClick={this.handleReload}
              className="tg-button w-full"
            >
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
